const TAG_TO_AVATAR = {
    sport: "sport",
    ocean: "ocean",
    movie: "movie",
    entertainment: "entertainment",
    culture: "culture",
    grammar: "grammar",
    education: "education",
    bedrock: "bedrock",
    technology: "technology",
    medical: "medical",
    society: "society",
    plant: "plant",
    capital: "capital",
    news: "news",
    food: "food",
    tv: "tv",
    work: "work",
    transport: "transport",
    animal: "animal",
    celebrity: "celebrity",
    city: "city",
    book: "book",
    language: "language",
    lifestyle: "culture",
    travel: "travel",
    geography: "geography",
    business: "business",
    health: "health",
    nature: "nature",
    music: "music",
    games: "games",
    /** General / default bucket (e.g. publisher dailyCrosswordTags "common") */
    common: "default",
    india: "india",
    mexico: "mexico",
    funny: "entertainment",
    art: "culture",
    fantasy: "games",
};

const warnedMissingTags = new Set();

/** "country" tag uses MUI PublicIcon in UI instead of /tag_avatar/country.svg */
export const tagUsesPublicIcon = (tagStr) => {
    if (!tagStr) return false;
    return String(tagStr).trim().toLowerCase() === "country";
};

/**
 * Returns the URL for a tag avatar image. Tag-specific icons for known tags.
 * When a new tag is not matched, uses /tag_avatar/default.svg.
 * @param {string} tagStr - The tag name (e.g. "Sport", "music", "Movie")
 * @returns {string} - Path to avatar, e.g. /tag_avatar/sport.svg or /tag_avatar/default.svg
 */
export const getTagAvatarUrl = (tagStr) => {
    if (!tagStr) return "/tag_avatar/default.svg";
    const key = String(tagStr).trim().toLowerCase();
    const avatar = TAG_TO_AVATAR[key];
    if (!avatar) {
        if (!warnedMissingTags.has(key)) {
            warnedMissingTags.add(key);
            // For new tag,
            // -- Add the new tag in the TAG_TO_AVATAR
            // -- Add the new tag in the locales/*.json for multiple languages
            console.warn(`[tagAvatarUtils] Tag "${tagStr}" (key: "${key}") not found in TAG_TO_AVATAR. Using default avatar.`);
        }
        return "/tag_avatar/default.svg";
    }
    return `/tag_avatar/${avatar}.svg`;
};
